module.exports = __webpack_public_path__ + "static/TP_LNSG_Website-1d377383d1b957bc07ee73e6fa87dd31.jpg";